import { action, computed, makeObservable, observable } from 'mobx';
import { OperationName, OperationStatus, OperationStatusses, ProgramEnrolmentSyncSummary } from '../../models';

export class OperationDashboardPageUiStore {
  @observable operationStatus = new Map<OperationName, OperationStatus>();
  @observable programEnrolmentSyncSummary: ProgramEnrolmentSyncSummary | undefined = undefined;

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.operationStatus.clear();
    this.programEnrolmentSyncSummary = undefined;
  }

  @action
  setOperationStatus(name: OperationName, status: OperationStatus): void {
    this.operationStatus.set(name, status);
  }

  @action
  markOperationInProgress(name: OperationName): void {
    this.operationStatus.set(name, {
      correlationId: '',
      operationName: name,
      status: OperationStatusses.InProgress,
      progress: 0,
    });
  }

  @action
  setProgramEnrolmentSyncSummary(summary: ProgramEnrolmentSyncSummary): void {
    this.programEnrolmentSyncSummary = summary;
  }

  @action
  removeOperationStatus(name: OperationName): void {
    this.operationStatus.delete(name);
  }

  @computed
  get isOperationInProgress(): boolean {
    return Array.from(this.operationStatus.values()).some(
      status => status.status === 'InProgress'
    );
  }

  getOperationStatusProgress(name: OperationName): number | undefined {
    return this.operationStatus.get(name)?.progress;
  }

  isOperationStatusInProgress(name: OperationName): boolean {
    return this.operationStatus.get(name)?.status === 'InProgress';
  }

  isOperationStatusFailed(name: OperationName): boolean {
    return this.operationStatus.get(name)?.status === 'Failed';
  }
}
